export default "__VITE_ASSET__CSdLhMkA__"